import { render, staticRenderFns } from "./CellRendererStatus.vue?vue&type=template&id=061996b3&"
import script from "./CellRendererStatus.vue?vue&type=script&lang=js&"
export * from "./CellRendererStatus.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererStatus.vue?vue&type=style&index=0&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports